import { render, staticRenderFns } from "./CompetenceLastYear.vue?vue&type=template&id=bbf7aade&scoped=true&lang=pug"
import script from "./CompetenceLastYear.vue?vue&type=script&lang=js"
export * from "./CompetenceLastYear.vue?vue&type=script&lang=js"
import style0 from "./CompetenceLastYear.vue?vue&type=style&index=0&id=bbf7aade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf7aade",
  null
  
)

export default component.exports